export var TableQueryBarType;
(function (TableQueryBarType) {
    TableQueryBarType["professionalBar"] = "professionalBar";
    TableQueryBarType["filterBar"] = "filterBar";
})(TableQueryBarType || (TableQueryBarType = {}));
